export default __webpack_public_path__ + "svg/logo-bw-new.svg?21a6f205";